export enum TrackNavArea {
    NavTop = 'TopNav',
    NavBottom = 'BottomNav',
    NavSub = 'SubNav',
    NavLive = 'LiveNav',
    NavVirtual = 'VirtualNav',
    NavBreadcrumb = 'Breadcrumb',
}
